import React, { useEffect, useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { ColorPicker } from 'primereact/colorpicker';
import { Slider } from 'primereact/slider';
import { InputText } from 'primereact/inputtext';

// Editor de atributos de forma para o MapBox (espelha ShapesAttributesEditor do
// mapa Google). Emite um patch plano via onApply — não depende de objeto nativo.
// `shape` é um item de drawnShapes (MapboxMap).
export default function ShapeAttributesEditor({ show, shape, onHide, onApply }) {
    const [name, setName] = useState('');
    const [fillColor, setFillColor] = useState('#3bb2d0');
    const [fillOpacity, setFillOpacity] = useState(0.5);
    const [strokeColor, setStrokeColor] = useState('#000000');
    const [strokeWeight, setStrokeWeight] = useState(3);
    const [radiusMeters, setRadiusMeters] = useState(0);

    // Ressincroniza o formulário sempre que a forma em edição muda.
    useEffect(() => {
        if (!shape) return;
        setName(shape.name ?? '');
        setFillColor(shape.fillColor ?? '#3bb2d0');
        setFillOpacity(shape.fillOpacity ?? 0.5);
        setStrokeColor(shape.strokeColor ?? '#000000');
        setStrokeWeight(shape.strokeWeight ?? 3);
        setRadiusMeters(Math.round(shape.radiusMeters ?? 0));
    }, [shape]);

    const isCircle = shape?.type === 'Círculo';

    // O ColorPicker do PrimeReact devolve o hex sem '#'.
    const withHash = (v) => (v?.startsWith('#') ? v : `#${v}`);

    const apply = () => {
        onApply({
            name,
            fillColor,
            fillOpacity: Number(fillOpacity),
            strokeColor,
            strokeWeight: Number(strokeWeight),
            radiusMeters: Number(radiusMeters),
        });
    };

    return (
        <Dialog header="Editar Forma" visible={show} style={{ width: '32rem', maxWidth: '90vw' }} modal onHide={onHide}>
            <div className="form-group">
                <label htmlFor="shapeName">Rótulo</label>
                <InputText
                    id="shapeName"
                    className="form-control"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                />
            </div>

            <div className="form-group">
                <div className="d-flex">
                    <div style={{ width: '50%' }}>
                        <label className="d-block">Cor de Preenchimento</label>
                        <ColorPicker value={fillColor} onChange={(e) => setFillColor(withHash(e.value))} />
                    </div>
                    <div style={{ width: '50%' }}>
                        <label className="d-block">Cor da Borda</label>
                        <ColorPicker value={strokeColor} onChange={(e) => setStrokeColor(withHash(e.value))} />
                    </div>
                </div>
            </div>

            <div className="form-group">
                {/* O Slider do PrimeReact 6 trunca o valor para inteiro (Math.floor),
                    então trabalhamos em porcentagem (10–100) e convertemos para 0.1–1. */}
                <label className="d-block">Opacidade do Preenchimento: {Math.round(fillOpacity * 100)}%</label>
                <Slider
                    value={Math.round(fillOpacity * 100)}
                    onChange={(e) => setFillOpacity(e.value / 100)}
                    min={10}
                    max={100}
                    step={10}
                />
            </div>

            <div className="form-group">
                <label className="d-block">Espessura da Borda: {strokeWeight}</label>
                <Slider value={strokeWeight} onChange={(e) => setStrokeWeight(e.value)} min={1} max={10} step={1} />
            </div>

            {isCircle && (
                <div className="form-group">
                    <label htmlFor="shapeRadius">Raio (m)</label>
                    <InputText
                        id="shapeRadius"
                        type="number"
                        min="1"
                        className="form-control"
                        value={radiusMeters}
                        onChange={(e) => setRadiusMeters(e.target.value)}
                    />
                </div>
            )}

            <button className="btn btn-sm btn-primary btn-block mt-2" onClick={apply}>
                Aplicar
            </button>
        </Dialog>
    );
}
